import { STOP_BOOKINGS_LOADING } from "./types";

const stopBookingsLoading = () => ({
  type: STOP_BOOKINGS_LOADING,
});

export default stopBookingsLoading;
